export default __webpack_public_path__ + "static/media/gallery_02.79e86992.jpg";